import { Objective, ObjectivesItem } from "@examspark/types";

export const escapeRegExp = (string: string) => {
  return string.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
};

export const fuzzyMatchObjective = (
  objective: Partial<Objective>,
  query: string,
) => {
  const fuzzyAbbr = objective.abbreviation?.replace(/[^a-zA-Z0-9]/g, "");

  if (
    !!query.length &&
    !objective.content?.match(new RegExp(escapeRegExp(query), "i")) &&
    !objective.abbreviation?.match(new RegExp(escapeRegExp(query), "i")) &&
    !fuzzyAbbr?.match(new RegExp(escapeRegExp(query), "i"))
  ) {
    return false;
  }

  return true;
};

// The shared compare logic for objectives. Returns a value appropriate for use
// with Array.sort.
export const objectiveCompareFn = (
  a: Objective | null | undefined,
  b: Objective | null | undefined,
) => {
  if (a == null || b == null) return 0;

  if (a.scope === b.scope) {
    if (a.sequence == null || b.sequence == null) return 0;

    return a.sequence - b.sequence;
  }

  if (a.scope == null || b.scope == null) return 0;

  return a.scope.localeCompare(b.scope);
};

export const sortObjectives = <T extends Objective>(objectives: T[]) =>
  [...objectives].sort(objectiveCompareFn);

export const sortObjectivesItems = <T extends ObjectivesItem>(
  objectives: T[],
) =>
  [...objectives].sort((a, b) => objectiveCompareFn(a.objective, b.objective));
